import { Button, Modal } from 'react-bootstrap';
import { useCompactPortrait } from 'components/navigation/NavigationContext';

export default function FullScreenModal({ show, handleClose, title, ModalBodyComponent, ModalFooterComponent = null }) {
  const compact = useCompactPortrait();
  return (
    <Modal
      show={show}
      onHide={handleClose}
      fullscreen={true}
      enforceFocus={!compact}
    >
      <Modal.Header>
        <img
          src="/TMLogo.png"
          alt="Toastmasters Logo"
          className="modal-header-logo"
          onClick={handleClose}
          style={{ cursor: 'pointer' }}
        />
        <Modal.Title className="modal-header-title">
          {title || "FULLSCREEN"}
        </Modal.Title>
        <Button
          type="button"
          variant="link"
          className="fullscreen-modal-close-btn ms-auto"
          onClick={handleClose}
          aria-label="Close modal"
        >
          <i className="bi bi-x-lg" aria-hidden="true" />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {ModalBodyComponent ? ModalBodyComponent : null}
      </Modal.Body>
      {ModalFooterComponent ? <Modal.Footer>{ModalFooterComponent}</Modal.Footer> : null}
    </Modal>
  );
}